export enum FileOrLink {
    File,
    Link,
    SFTP
};